'use strict';

(function () {
  if (window.__klaviyoBisI18nInit) {
    return;
  }
  window.__klaviyoBisI18nInit = true;

  var COPY = {
    en: {
      button: 'Notify Me When Available',
      aria: 'Notify me when this product becomes available',
    },
    es: {
      button: 'Notificarme cuando est\u00e9 disponible',
      aria: 'Quiero que me avisen cuando vuelva a estar disponible',
    },
    fr: {
      button: 'Me notifier lors de la disponibilit\u00e9',
      aria: 'Me notifier lorsque ce produit sera disponible',
    },
    de: {
      button: 'Benachrichtigen Sie mich bei Verf\u00fcgbarkeit',
      aria: 'Bitte benachrichtigen, sobald der Artikel verf\u00fcgbar ist',
    },
    it: {
      button: 'Avvisami quando \u00e8 disponibile',
      aria: 'Avvisami quando questo prodotto torna disponibile',
    },
    ja: {
      button: '\u5165\u8377\u6642\u306b\u901a\u77e5\u3059\u308b',
      aria: '\u8a72\u5f53\u5546\u54c1\u304c\u518d\u5165\u8377\u3057\u305f\u3089\u901a\u77e5\u3059\u308b',
    },
    nl: {
      button: 'Laat het me weten wanneer beschikbaar',
      aria: 'Laat het me weten zodra dit product beschikbaar is',
    },
    tr: {
      button: 'Stokta olunca haber ver',
      aria: 'Bu \u00fcr\u00fcn stokta olunca haber ver',
    },
  };

  var TLD_MAP = {
    fr: 'fr',
    de: 'de',
    es: 'es',
    it: 'it',
    jp: 'ja',
    nl: 'nl',
    tr: 'tr',
    com: 'en',
    store: 'en',
    uk: 'en',
    eu: 'en',
  };

  function normalizeKey(value) {
    if (!value || typeof value !== 'string') {
      return '';
    }
    return value.toLowerCase();
  }

  function resolveFromCopy(candidate) {
    var key = normalizeKey(candidate);
    if (!key) {
      return '';
    }
    if (COPY[key]) {
      return key;
    }
    var base = key.split('-')[0];
    if (COPY[base]) {
      return base;
    }
    if (key === 'jp') {
      return 'ja';
    }
    return '';
  }

  function detectLocaleKey() {
    var locale = '';

    if (window.Shopify && typeof window.Shopify.locale === 'string') {
      locale = resolveFromCopy(window.Shopify.locale);
      if (locale) {
        return locale;
      }
    }

    if (document.documentElement && document.documentElement.lang) {
      locale = resolveFromCopy(document.documentElement.lang);
      if (locale) {
        return locale;
      }
    }

    var host = String((window.location && window.location.hostname) || '');
    if (host) {
      var parts = host.split('.');
      var tld = parts.length ? parts[parts.length - 1].toLowerCase() : '';
      if (TLD_MAP[tld]) {
        locale = resolveFromCopy(TLD_MAP[tld]);
        if (locale) {
          return locale;
        }
      }
    }

    return 'en';
  }

  function applyCopy(copy) {
    if (!copy || !copy.button) {
      return false;
    }

    var buttons = document.querySelectorAll(
      '#klaviyo-bis-button-container button, button.klaviyo-bis-trigger',
    );
    var updated = false;

    Array.prototype.forEach.call(buttons, function (button) {
      if (!button) {
        return;
      }
      if (button.textContent !== copy.button) {
        button.textContent = copy.button;
      }
      var ariaText = copy.aria || copy.button;
      if (button.getAttribute('aria-label') !== ariaText) {
        button.setAttribute('aria-label', ariaText);
      }
      updated = true;
    });

    return updated;
  }

  function init() {
    if (
      !document.body ||
      !document.body.classList ||
      !document.body.classList.contains('template-product')
    ) {
      return;
    }

    var copy = COPY[detectLocaleKey()] || COPY.en;

    var applyNow = function () {
      return applyCopy(copy);
    };

    applyNow();

    var observer = new MutationObserver(function () {
      applyNow();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    document.addEventListener('product:variant-change', function () {
      applyNow();
      window.setTimeout(applyNow, 60);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
